import { render, staticRenderFns } from "./NominacionRegaliasForm.vue?vue&type=template&id=10ab9307"
import script from "./NominacionRegaliasForm.vue?vue&type=script&lang=js"
export * from "./NominacionRegaliasForm.vue?vue&type=script&lang=js"
import style0 from "./NominacionRegaliasForm.vue?vue&type=style&index=0&id=10ab9307&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports